export default __webpack_public_path__ + "static/media/gtc.91d0c3ec.jpg";